module.exports = __webpack_public_path__ + "img/014-search.7dac2e26.svg";